import React from 'react'
import { Button, TextField } from '@material-ui/core/index'
import { strings } from '../../../localization/strings'
import { connect } from 'react-redux'
import {
    userPasswordLoginAction,
    logOutAction,
} from '../../../actions/usersActions'
import { getStatusAction, getAppConfigAction } from '../../../actions/appActions'
import routes from '../../router/routes'
import Loader from '../../loaders'
import { appEnabled } from '../../../server/common'
import {
    WooCommerceLogoIcon,
    TiendaNubeLogoIcon,
    ShopifyLogoIcon,
    BillowShopLogoIcon,
} from '../../components/icons'
import withStyles from '@material-ui/core/styles/withStyles'
import { TIENDA_NUBE_APP_URL } from '../../../server/connection'
import logotipoPudo from '../../../assets/icons/logo-pudo-en-tu-camino.png'

const BillowshopEnabled = process.env.REACT_APP_BILLOWSHOP_ENABLED

const WooCommerceButton = withStyles((theme) => ({
    root: {
        backgroundColor: '#9B5C8F',
        transition: 'flex 0.5s',
        '&:hover': {
            backgroundColor: '#9B5C8F',
            flex: 1,
        },
    },
}))(Button)

const ShopifyButton = withStyles((theme) => ({
    root: {
        backgroundColor: '#95BF47',
        transition: 'flex 0.5s',
        '&:hover': {
            backgroundColor: '#95BF47',
            flex: 1,
        },
    },
}))(Button)

const TiendaNubeButton = withStyles((theme) => ({
    root: {
        backgroundColor: '#2C3357',
        transition: 'flex 0.5s',
        '&:hover': {
            backgroundColor: '#2C3357',
            flex: 1,
        },
    },
}))(Button)

const BillowShopButton = withStyles((theme) => ({
    root: {
        backgroundColor: '#EB3569',
        transition: 'flex 0.5s',
        '&:hover': {
            backgroundColor: '#EB3569',
            flex: 1,
        },
    },
}))(Button)

const flexCenter = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
}

const styles = theme => ({
    logotipoPudo: {
        width: '250px',
        display: 'block',
        margin: '0 auto 30px'
    },
    pageContainer: {
        ...flexCenter
    },
    loginForm: {
        ...flexCenter,
        textAlign: 'center',
        maxWidth: '400px',
        width: '400px',
        marginTop: 10,
        marginBottom: 10,
        maxWidth: '100%',
    },
    textField: {
        maxWidth: 340
    },
    loginBtn: {
        marginTop: 20,
        marginBottom: 5,
        height: 50,
        maxWidth: 340,
        borderRadius: 50,
        color: '#fff',
    },
    resetPasswordLink: {
        maxWidth: 340,
        fontSize: '12px'
    },
    registerBtn: {
        marginBottom: 40,
        height: 50,
        maxWidth: 340,
        borderRadius: 50,
    },
    logInInstallApps: {
        marginTop: '40px',
        marginBottom: '20px'
    },
    shopApps: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        textAlign: 'center',
        maxWidth: '450px',
        width: '450px',
        marginTop: 10,
        maxWidth: '100%',
        marginBottom: 40,
    },
    shopAppsBtn: {
        margin: '5px 10px',
        height: '60px',
        width: '60px',
        minWidth: '60px',
        borderRadius: 50,
        color: '#fff',
    },
    shopAppsIcon: {
        width: '50px', height: '50px',
    },
    shopAppsText: {
        fontSize: '12px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        marginLeft: '3px'
    },
    hideShopAppsBtn: {
        display: 'none'
    }
})

class Component extends React.Component {
    state = {
        ready: true,
        userName: '',
        password: '',
        userNameError: '',
        passwordError: '',
        showPlatformWoocomerceRegisterButton: false,
        showPlatformShopifyRegisterButton: false,
        showPlatformTiendanubeRegisterButton: false,
        showPlatformBillowshopRegisterButton: false,
        showPlatformPudoRegisterButton: false
    }

    componentDidMount() {
        this.props
            .getAppConfigAction()
            .then((response) => {
                this.setState({
                    showPlatformWoocomerceRegisterButton: response.showPlatformWoocomerceRegisterButton,
                    showPlatformShopifyRegisterButton: true,
                    showPlatformTiendanubeRegisterButton: response.showPlatformTiendanubeRegisterButton,
                    showPlatformBillowshopRegisterButton: response.showPlatformBillowshopRegisterButton,
                    showPlatformPudoRegisterButton: true
                })
            })
            .catch((error) => {
                console.log('err', error)
            })
    }

    validateForm = () => {
        this.setState({
            userNameError: !this.state.userName,
            passwordError: !this.state.password,
        })
        return !(!this.state.userName || !this.state.password)
    }

    getStatus = () => {
        this.props
            .getStatusAction(this.props.history)
            .then((status) => {
                if (appEnabled(status)) {
                    this.props.history.push(routes.orders.path)
                    this.setState({ ready: true })
                }
            })
            .catch((error) => {
                if (error.additionalData)
                    window.showDialog({ message: error.additionalData }, () =>
                        this.props.logOutAction()
                    )
                else window.showDialog(error, () => this.props.logOutAction())
            })
    }

    authenticate = () => {
        this.props
            .userPasswordLoginAction(
                this.state.userName,
                this.state.password,
                this.props.history
            )
            .then(() => this.getStatus())
            .catch((error) =>
                window.showDialog(error, () => this.props.logOutAction())
            )
    }

    handleSubmit = () => {
        if (!this.validateForm()) return
        this.setState({ ready: false })
        this.authenticate()
    }

    render() {
        const { classes } = this.props
        const { showPlatformWoocomerceRegisterButton,
            showPlatformShopifyRegisterButton,
            showPlatformTiendanubeRegisterButton,
            showPlatformBillowshopRegisterButton,
            showPlatformPudoRegisterButton } = this.state

        if (!this.state.ready) return <Loader />
        return (
            <div style={{ marginTop: '30px' }}>
                <img src={logotipoPudo} className={classes.logotipoPudo} onClick={() => this.props.history.push('/')} />
                <div className={`page-container, ${classes.pageContainer}`}>
                    <div className={classes.loginForm}
                    >
                        <TextField
                            className={classes.textField}
                            label={strings.logInUserName}
                            fullWidth
                            onChange={(ev) =>
                                this.setState({
                                    userName: ev.target.value,
                                    userNameError: '',
                                })
                            }
                            value={this.state.userName}
                            error={!!this.state.userNameError}
                        />
                        <TextField
                            className={classes.textField}
                            label={strings.logInPassword}
                            fullWidth
                            onChange={(ev) =>
                                this.setState({
                                    password: ev.target.value,
                                    passwordError: '',
                                })
                            }
                            type={'password'}
                            value={this.state.password}
                            error={!!this.state.passwordError}
                            onKeyPress={(e) =>
                                e.key === 'Enter' ? this.handleSubmit() : null
                            }
                        />
                        <Button
                            className={classes.loginBtn}
                            color='primary'
                            label={strings.logInButton}
                            onClick={this.handleSubmit}
                            variant="contained"
                            fullWidth
                        >
                            {strings.logInButton}
                        </Button>
                        <Button
                            className={classes.resetPasswordLink}
                            label={strings.resetPasswordLink}
                            color="primary"
                            fullWidth
                            onClick={() =>
                                this.props.history.push(routes.resetPassword.path)
                            }
                        >
                            {strings.resetPasswordLink}
                        </Button>

                    </div>
                    <i className={
                        `${classes.logInInstallApps} 
                        ${!showPlatformWoocomerceRegisterButton
                            && !showPlatformShopifyRegisterButton
                            && !showPlatformTiendanubeRegisterButton
                            && !showPlatformBillowshopRegisterButton
                            ? classes.hideShopAppsBtn
                            : null}`
                    }>
                        {strings.logInInstallApps}
                    </i>
                    <div className={`shopApps, ${classes.shopApps}`} >
                        <TiendaNubeButton
                            className={`${classes.shopAppsBtn} ${!showPlatformTiendanubeRegisterButton ? classes.hideShopAppsBtn : null}`}
                            variant="contained"
                            color="primary"
                            fullWidth
                            href={TIENDA_NUBE_APP_URL}
                        >
                            <TiendaNubeLogoIcon
                                edge="start"
                                style={{ paddingLeft: '7px' }}
                                className={classes.shopAppsIcon}
                            />
                            <p className={classes.shopAppsText}>Tienda Nube</p>
                        </TiendaNubeButton>
                        <WooCommerceButton
                            className={`${classes.shopAppsBtn} ${!showPlatformWoocomerceRegisterButton ? classes.hideShopAppsBtn : null}`}
                            variant="contained"
                            color="primary"
                            size="large"
                            fullWidth
                            onClick={() =>
                                this.props.history.push(routes.wooCommerceHelp.path)
                            }
                        >
                            <WooCommerceLogoIcon
                                edge="start"
                                className={classes.shopAppsIcon}
                            />
                            <p className={classes.shopAppsText}>WooComerce</p>
                        </WooCommerceButton>
                        <ShopifyButton
                            className={`${classes.shopAppsBtn} ${!showPlatformShopifyRegisterButton ? classes.hideShopAppsBtn : null}`}
                            variant="contained"
                            color="primary"
                            size="large"
                            fullWidth
                            onClick={() =>
                                this.props.history.push(routes.shopifyHelp.path)
                            }
                        >
                            <ShopifyLogoIcon className={classes.shopAppsIcon} />
                            <p className={classes.shopAppsText}>Shopify</p>
                        </ShopifyButton>
                        {BillowshopEnabled === '1' ? (
                            <BillowShopButton
                                className={`${classes.shopAppsBtn} ${!showPlatformBillowshopRegisterButton ? classes.hideShopAppsBtn : null}`}
                                variant="contained"
                                color="primary"
                                size="large"
                                fullWidth
                                onClick={() =>
                                    this.props.history.push({
                                        pathname: routes.registrationForm.path,
                                        search: '?platform=billowshop',
                                    })
                                }
                            >
                                <BillowShopLogoIcon className={classes.shopAppsIcon} />
                                <p className={classes.shopAppsText}>BillowShop</p>
                            </BillowShopButton>
                        ) : null}
                    </div>

                    <Button
                        className={`${classes.registerBtn} ${!showPlatformPudoRegisterButton ? classes.hideShopAppsBtn : null}`}
                        label={strings.logInRegister}
                        color='primary'
                        variant="outlined"
                        fullWidth
                        onClick={() =>
                            this.props.history.push(
                                routes.registrationForm.path
                            )
                        }
                    >
                        {strings.logInRegister}
                    </Button>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = {
    userPasswordLoginAction,
    getStatusAction,
    getAppConfigAction,
    logOutAction,
}
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Component))